export default __webpack_public_path__ + "static/media/ncp0.b511dbab.jpg";